"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _core = require("core.ui-module_site-components");
var _KbaAnswer = _interopRequireDefault(require("../../api/auth/KbaAnswer"));
var _KbaResponseStepResponse = _interopRequireDefault(require("../../api/auth/KbaResponseStepResponse"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class KbaResponseStep extends _react.default.Component {
  constructor(props) {
    var _props$stepResponse;
    super(props);
    _defineProperty(this, "handleChange", (questionId, choiceId) => {
      var {
        answers,
        additionalData
      } = this.state;
      const totalQuestions = additionalData.questions.length;
      answers[questionId] = choiceId === undefined ? !formData[questionId] : choiceId;
      const disabled = Object.keys(answers).length != totalQuestions;
      this.setState({
        answers: answers,
        disabled: disabled
      });
    });
    this.state = {
      isLoading: false,
      errorMessage: '',
      answers: [],
      disabled: true,
      additionalData: props === null || props === void 0 || (_props$stepResponse = props.stepResponse) === null || _props$stepResponse === void 0 ? void 0 : _props$stepResponse.additionalData
    };
  }
  submit(e) {
    e.preventDefault();
    const {
      answers
    } = this.state;
    this.setState({
      errorMessage: '',
      isLoading: true,
      answers: [],
      disabled: true
    });
    const step = new _KbaResponseStepResponse.default();
    Object.keys(answers).forEach(questionId => {
      const answer = new _KbaAnswer.default();
      answer.questionId = questionId;
      answer.answerId = answers[questionId];
      step.kbaAnswers.push(answer);
    });
    this.props.listener(this, step);
  }
  render() {
    const {
      isLoading,
      disabled,
      additionalData
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("form", {
      id: "kbaForm"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "modal is-active has-background-white"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "modal-background"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "box modal-content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "login-box content has-min-height-450"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title",
      dangerouslySetInnerHTML: {
        __html: 'Security Verification Questions'
      }
    }), isLoading ? /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay is-active`
    }, /*#__PURE__*/_react.default.createElement(_core.Spinner, null)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
      className: "subtitle"
    }, "Please answer the following questions to verify your identity."), /*#__PURE__*/_react.default.createElement("div", {
      className: "content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "has-text-left"
    }, isLoading ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null) : additionalData.questions.map((x, i) => /*#__PURE__*/_react.default.createElement("div", {
      className: "columns ",
      key: `q_${x.questionId}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "has-text-weight-bold"
    }, i + 1, ". ", x.text), /*#__PURE__*/_react.default.createElement("div", {
      className: "pl-4"
    }, x.helpText), /*#__PURE__*/_react.default.createElement("div", {
      className: "pl-3"
    }, x.choices.map(y => /*#__PURE__*/_react.default.createElement("div", {
      key: `a_${y.choiceId}`
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "radio",
      name: `question${x.questionId}`,
      className: "m-2",
      onChange: e => {
        this.handleChange(`${x.questionId}`, `${y.choiceId}`);
      }
    }), y.text)))))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "field field-submit-button"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "is-primary",
      handleClick: e => this.submit(e),
      disabled: disabled
    }, "Next")))))))));
  }
}
KbaResponseStep.propTypes = {
  listener: _propTypes.default.func.isRequired,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  })
  //  KbaResponseStep: PropTypes.shape({
  //    additionalData: PropTypes.shape({
  //      message: PropTypes.string,
  //    }),
  //  }),
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(KbaResponseStep);
//# sourceMappingURL=KbaResponseStep.js.map